module.exports = __webpack_public_path__ + "img/checkBoxOffBlack.bbc8d8b2.svg";